import { Input, Select, Table, Tag, Typography } from "antd";
import GlassPanel from "../../components/common/glassPanel";
import { workspaceItems } from "../../data/admin";

const { Text } = Typography;

export default function WorkspaceScreen() {
  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel
        eyebrow="Internal Coordination"
        title="Workspace"
        actions={
          <div className="flex flex-wrap gap-2">
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All statuses" },
                { value: "in-progress", label: "In progress" },
                { value: "blocked", label: "Blocked" },
              ]}
              style={{ width: 150 }}
            />
            <Input.Search placeholder="Search initiatives" style={{ width: 220 }} />
          </div>
        }
      >
        <Text type="secondary">
          Shared initiatives, staffing, and operating work should live outside the sector modules.
        </Text>
      </GlassPanel>

      <GlassPanel title="Shared Initiatives">
        <Table
          rowKey="title"
          pagination={false}
          dataSource={workspaceItems}
          columns={[
            { title: "Initiative", dataIndex: "title" },
            { title: "Owner", dataIndex: "owner" },
            {
              title: "Status",
              dataIndex: "status",
              render: (value: string) => (
                <Tag color={value === "Blocked" ? "error" : value === "In progress" ? "processing" : "success"}>{value}</Tag>
              ),
            },
            { title: "Summary", dataIndex: "summary" },
          ]}
        />
      </GlassPanel>
    </div>
  );
}
